import {
  BrowserRouter as BrouserRouter,
  Navigate,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import '@mantine/core/styles.css';
import "./App.css";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Entity from "./pages/Entity";
import Header from "./components/Header";
import Home from "./pages/Home";
import { createTheme, MantineProvider, Button, Accordion } from "@mantine/core";
import Footer from "./components/Footer";
import { ThemeProvider } from "./components/ThemeContext";
import Dashboard from "./pages/Dashboard";
import UserProfile from "./components/UserProfile";
import { StepCard } from "./components/StepCard";
import Wallet from "./pages/Wallet";
import Staking from "./pages/Staking";
import P2pTrading from "./pages/P2pTrading";
import DepositCrypto from "./pages/DepositCrypto";
import WithdrawCrypto from "./pages/WithdrawCrypto";
import SimpleEarn from "./pages/SimpleEarn";
import Affiliate from "./pages/Affiliate";
import AffiliateJoin from "./pages/AffiliateJoin";
import Markets from "./pages/Markets";
import Overview from "./pages/Overview";
import TradingData from "./pages/TradingData";
import TokenUnlock from "./pages/TokenUnlock";
import MarketAssetDetail from "./pages/MarketAssetDetail";
import TradingTerminal from "./pages/TradingTerminal";
import CandlestickChart from "./charts/CandlestickChart";
import TrandingDataChart from "./charts/TrandingDataChart";
import AssetOverview from "./pages/AssetOverview";
import AssetSpot from "./pages/AssetSpot";
import Rewards from "./pages/Rewards";
import Download from "./pages/Download";
import Loan from "./pages/Loan";
import EthStaking from "./pages/EthStaking";
import SolStaking from "./pages/SolStaking";
import BuyCrypto from "./pages/BuyCrypto";
import BuyAndSell from "./pages/BuyAndSell";
import LimitBuy from "./pages/LimitBuy";
import RecurringBuy from "./pages/RecurringBuy";
import Convert from "./pages/Convert";
import CopyTrading from "./pages/CopyTrading";
import Spot from "./pages/Spot";
import Futures from "./pages/Futures";
import Airdrop from "./pages/Airdrop";
import Account from "./pages/Account";
import Security from "./pages/Security";
import BinanceFutures from "./pages/BinanceFutures";
import SupportCenter from "./support/SupportCenter";
import ChatSupport from "./pages/ChatSupport";
import Reset2fa from "./support/Reset2fa";
import ResetPassword from "./support/ResetPassword";
import Correction from "./support/Correction";
import Inheritance from "./support/Inheritance";
import CryptoDeposit from "./support/CryptoDeposit";
import P2pOrder from "./pages/P2pOrder";
import TransactionHistory from "./pages/TransactionHistory";
import FiatDepositAppeal from "./support/FiatDepositAppeal";
import FiatWithdrawal from "./support/FiatWithdrawal";
import P2pPerformance from "./support/P2pPerformance";
import RefundFundsP2p from "./support/RefundFundsP2p";
import ReferralDashboard from "./pages/ReferralDashboard";
import DisableAccount from "./support/DisableAccount";
import PersonalInformationCorrection from "./support/PersonalInformationCorrection";
import ProofOfReserves from "./pages/ProofOfReserves";
import Blogs from "./pages/Blogs";
import BlogsPage from "./pages/BlogsPage";
import TradingInsight from "./pages/TradingInsight";
import Announcement from "./Announcement/Announcement";
import AnnouncementAll from "./Announcement/AnnouncementAll";
import LatestBinanceNews from "./Announcement/LatestBinanceNews";
import LatestActivities from "./Announcement/LatestActivities";
import NewFiatListings from "./Announcement/NewFiatListings";
import ApiUpdates from "./Announcement/ApiUpdates";
import MaintenanceUpdates from "./Announcement/MaintenanceUpdates";
import CryptoAirdrop from "./Announcement/CryptoAirdrop";
import Delisting from "./Announcement/Delisting";
import { BinanceTickerProvider } from "./services/BinanceTickerContext";
import { BrandingProvider } from "./components/BrandingContext";
import { SiteConfigProvider } from "./components/SiteConfigContext";
import CmsPage from "./pages/CmsPage";
import RouteSeo from "./components/RouteSeo";
import TrafficTracker from "./components/TrafficTracker";

const theme = createTheme({
  components: {
    Button: Button.extend({
      defaultProps: {
        color: "#fdd25dff",
        variant: "filled",
        size: "lg",
      },
    }),
  },
});

const RequireAuth = ({ children, redirectTo = "/login" }) => {
  const location = useLocation();
  if (!localStorage.getItem("token")) {
    const to = redirectTo === "/signup" ? { pathname: redirectTo, search: location.search } : redirectTo;
    return <Navigate to={to} replace />;
  }
  return children;
};
const LegacyTradingRedirect = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: "/trade", search: location.search, hash: location.hash }} replace />;
};

const App = () => {
  return (
    <>
      <MantineProvider theme={theme}>
        <ThemeProvider>
          <BinanceTickerProvider>
            <BrandingProvider>
            <SiteConfigProvider>
            <BrouserRouter>
            <TrafficTracker />
            <RouteSeo />
            <Routes>
            <Route path={"/"} element={<Home />}></Route>
            <Route path={"/login"} element={<Login />}></Route>
            <Route path={"/signup"} element={<Signup />}></Route>
            <Route path={"/entity"} element={<Entity />}></Route>
            <Route path={"/header"} element={<Header />}></Route>
            <Route path={"/footer"} element={<Footer />}></Route>
            <Route path={"/home"} element={<Home />}></Route>
            <Route path={"/dashboard"} element={<Navigate to="/user/dashboard" replace />}></Route>
            <Route path={"/user/dashboard"} element={<RequireAuth><Dashboard /></RequireAuth>}></Route>
            <Route path={"/userProfile"} element={<UserProfile />}></Route>
            <Route path={"/stepCard"} element={<StepCard />}></Route>
            <Route path={"/wallet"} element={<Wallet />}></Route>
            <Route path={"/staking"} element={<Staking />}></Route>
            <Route path={"/ethStaking"} element={<EthStaking />}></Route>
            <Route path={"/solStaking"} element={<SolStaking />}></Route>
            <Route path={"/p2ptrading"} element={<P2pTrading />}></Route>
            <Route path={"/depositCrypto"} element={<DepositCrypto />}></Route>
            <Route path={"/withdrawCrypto"} element={<WithdrawCrypto />}></Route>
            <Route path={"/simpleEarn"} element={<SimpleEarn />}></Route>
            <Route path={"/affiliate"} element={<Affiliate />}></Route>
            {/* <Route path={"/referral"} element={<Referral />}></Route> */}
            <Route path={"/affiliateJoin"} element={<AffiliateJoin />}></Route>
            <Route path={"/convert"} element={<Convert />}></Route>
            <Route path={"/referralDashboard"} element={<RequireAuth><ReferralDashboard /></RequireAuth>}></Route>
            <Route path={"/referral/earn-together/refer2earn-usdc/claim"} element={<RequireAuth redirectTo="/signup"><ReferralDashboard /></RequireAuth>}></Route>
            <Route path={"/markets"} element={<Markets />}></Route>
            <Route path={"/trade"} element={<TradingTerminal />} />
            <Route path={"/trade"} element={<TradingTerminal />} />
            <Route path={"/bnbUsdt"} element={<LegacyTradingRedirect />} />
            <Route path={"/candlestickChart"} element={<CandlestickChart />} />
            <Route path={"/tradingDataChart"} element={<TrandingDataChart />} />
            <Route path={"/rewards"} element={<Rewards />} />
            <Route path={"/download"} element={<Download />} />
            <Route path={"/loan"} element={<Loan />} />
            <Route path={"/airdrop"} element={<Airdrop />} />
            <Route path={"/account"} element={<Account />} />
            <Route path={"/security"} element={<Security/>} />
            <Route path={"/futures"} element={<BinanceFutures/>} />
            <Route path={"/spot-order"} element={<Navigate to="/markets/overview" replace />} />
            <Route path={"/p2p-order"} element={<P2pOrder/>} />
            <Route path={"/transaction-history"} element={<TransactionHistory/>} />
            <Route path={"/fiat-deposit-appeal"} element={<FiatDepositAppeal/>} />
            <Route path={"/fiat-withdrawal"} element={<FiatWithdrawal/>} />
            <Route path={"/p2p-performance"} element={<P2pPerformance/>} />
            <Route path={"/refund-funds-p2p"} element={<RefundFundsP2p/>} />
            <Route path={"/disable-account"} element={<DisableAccount/>} />
            <Route path={"/personal-informartion-correction"} element={<PersonalInformationCorrection/>} />
            <Route path={"/proof-of-reserves"} element={<ProofOfReserves/>} />
            <Route path={"/blogs"} element={<Blogs/>} />
            <Route path={"/blogs-page"} element={<BlogsPage/>} />
            <Route path={"/trading-insight"} element={<TradingInsight/>} />


            <Route path={"/announcement"} element={<Announcement/>}>
                <Route path={"announcement-all"} element={<AnnouncementAll/>}></Route>
                <Route path={"latest-tillionx-news"} element={<LatestBinanceNews/>}></Route>
                <Route path={"latest-activities"} element={<LatestActivities/>}></Route>
                <Route path={"new-fiat-listings"} element={<NewFiatListings/>}></Route>
                <Route path={"api-updates"} element={<ApiUpdates/>}></Route>
                <Route path={"maintenance-updates"} element={<MaintenanceUpdates/>}></Route>
                <Route path={"crypto-airdrop"} element={<CryptoAirdrop/>}></Route>
                <Route path={"delisting"} element={<Delisting/>}></Route>
            </Route>


            <Route path={"/support-center"} element={<SupportCenter/>} />
            <Route path={"/page/:slug"} element={<CmsPage />} />
            <Route path={"/chat-support"} element={<ChatSupport/>} />
            <Route path={"/reset2fa"} element={<Reset2fa/>} />
            <Route path={"/reset-password"} element={<ResetPassword/>} />
            <Route path={"/correction"} element={<Correction/>} />
            <Route path={"/inheritance"} element={<Inheritance/>} />
            <Route path={"/crypto-deposit"} element={<CryptoDeposit/>} />



            {/* copy trading inner routes */}
            <Route path={"/copy-trading"} element={<CopyTrading />} >
              <Route path={"futures"} element={<Futures />} />
              <Route path={"spot"} element={<Spot />} />  
            </Route>

            {/* Buy crypto inner routes */}
            <Route path={"/buyCrypto"} element={<BuyCrypto />}>
              <Route path={"buyandsell"} element={<BuyAndSell />} />
              <Route path={"limitbuy"} element={<LimitBuy />} />
              <Route path={"recurringBuy"} element={<RecurringBuy />} />
            </Route>

            {/* assets inner routes */}
            <Route path={"/assetOverview"} element={<AssetOverview />}>
              <Route path={"assetSpot"} element={<AssetSpot />} />
            </Route>

            {/* market inner routes */}
            <Route path={"/markets"} element={<Markets />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path={"overview"} element={<Overview />} />
              <Route path={"tradingData"} element={<TradingData />} />
              <Route path={"tokenUnlock"} element={<TokenUnlock />} />
              <Route path={"asset/:symbol"} element={<MarketAssetDetail />} />
            </Route>
            </Routes>
            </BrouserRouter>
            </SiteConfigProvider>
            </BrandingProvider>
          </BinanceTickerProvider>
        </ThemeProvider>
      </MantineProvider>
    </>
  );
};

export default App;
